import { FC } from 'react';
import { TemplatesViewMode } from '../../config';
import { WhatsappTemplate } from '../../../types/whatsappTemplates';
import { WhatsappTemplateCard } from '../WhatsappTemplateCard';
import { WhatsappTemplateTable } from '../WhatsappTemplateTable';

type WhatsappTemplateListContentProps = {
  viewMode: TemplatesViewMode;
  items: WhatsappTemplate[];
  onEdit: (templateId: string) => void;
  onRequestDelete: (template: WhatsappTemplate) => void;
};

export const WhatsappTemplateListContent: FC<WhatsappTemplateListContentProps> = ({ viewMode, items, onEdit, onRequestDelete }) => {
  if (viewMode === 'table') {
    return (
      <div className='overflow-x-auto rounded-2xl border border-secondary-border bg-white'>
        <WhatsappTemplateTable items={items} onEdit={onEdit} onRequestDelete={onRequestDelete} />
      </div>
    );
  }

  return (
    <div className='grid gap-4 md:grid-cols-2 xl:grid-cols-4'>
      {items.map((item) => (
        <WhatsappTemplateCard key={item.id} template={item} onEdit={onEdit} onRequestDelete={onRequestDelete} />
      ))}
    </div>
  );
};
